import { FloatingWindow, WindowTaskbar } from './FloatingWindow';
import { useWindowStore, WindowConfig } from '../stores/windowStore';
import { FullCharacterSheet } from './FullCharacterSheet';
import { useCharacterStore } from '../stores/characterStore';

/**
 * Renders all open floating windows
 */
export function WindowManager() {
  const windows = useWindowStore((s) => s.windows);
  const windowList = Object.values(windows).filter((w) => w.state !== 'minimized' && w.state !== 'docked');

  return (
    <>
      {windowList.map((config) => (
        <WindowRenderer key={config.id} config={config} />
      ))}
      <WindowTaskbar />
    </>
  );
}

/**
 * Renders the appropriate content for a window type
 */
function WindowRenderer({ config }: { config: WindowConfig }) {
  const getWindowContent = () => {
    switch (config.type) {
      case 'character-sheet':
        return <CharacterSheetWindowContent config={config} />;
      default:
        return <div style={{ padding: 'var(--spacing-md)' }}>Unknown window type</div>;
    }
  };

  return (
    <FloatingWindow config={config}>
      {getWindowContent()}
    </FloatingWindow>
  );
}

/**
 * Character sheet content for floating windows
 */
function CharacterSheetWindowContent({ config }: { config: WindowConfig }) {
  const characterId = config.data?.characterId as string;
  const character = useCharacterStore((s) => s.characters.get(characterId));

  if (!character) {
    return (
      <div style={{ padding: 'var(--spacing-md)', color: 'var(--color-text-muted)' }}>
        Character not found
      </div>
    );
  }

  return <FullCharacterSheet character={character} />;
}
